import { Events, EventBus } from '~/lib/events'

export default async function({ route }) {
  if (process.server) return

  EventBus.$emit(Events.PageViewed, route)
}
